import { createFileRoute } from "@tanstack/react-router";

import { PublicOffer } from "@/features/billing";

const TermsPage = () => (
  <main data-page="terms" className="mx-auto w-full max-w-3xl px-6 py-8">
    <PublicOffer />
  </main>
);

// Оферта открывается без входа (`staticData.isPublic`): на неё ссылаются «Тарифы» и подвал.
export const Route = createFileRoute("/terms")({
  staticData: { isPublic: true },
  component: TermsPage,
});
